import { Platforms } from '../constants';
import { UrlParams } from '../enums';
import type { Platform } from '../types';
import { getUrlParam } from '../utils';

export default function usePlatform() {
  const platform = getUrlParam(UrlParams.PLATFORM);

  return platform !== null && Object.values(Platforms).includes(platform)
    ? (platform as Platform)
    : Platforms.MOBILE;
}
